export default __webpack_public_path__ + "static/media/web-dev Header.17d4dcd5.jpg";